import { render, staticRenderFns } from "./campus-access.vue?vue&type=template&id=3b803fda&"
import script from "./campus-access.vue?vue&type=script&lang=js&"
export * from "./campus-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports